// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"9c716fb4bfe48f17504d","303":"159a5d0a59c72e36230f","495":"31c4ab8ff3715e107da0"}[chunkId] + ".js";
};